"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageContainer = exports.BodyContentMarkdown = exports.TextContentWrapper = exports.FloatQuote = exports.TextContainer = exports.Wrapper = exports.Background = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variant = _interopRequireDefault(require("@styled-system/variant"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _gridContainer = require("../grid-container");

var _typography = require("../typography");

var _markdown = _interopRequireDefault(require("../markdown"));

var _buttonBase = _interopRequireDefault(require("../button/button-base"));

var _linkBase = _interopRequireDefault(require("../link/link-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Background = (0, _styledComponents["default"])('div').withConfig({
  displayName: "text-and-imagestyles__Background",
  componentId: "sc-89ga8u-0"
})(["height:75%;width:50%;margin-left:-1rem;grid-column:main-start / main-end;grid-row:1;align-self:stretch;background-image:url(", "?w=800);background-repeat:no-repeat;background-size:cover;opacity:0.2;@media ", "{height:87%;background-image:url(", ");margin-left:0;}"], function (props) {
  return props.backgroundImage;
}, function (props) {
  return props.theme.queries.desktopAndUp;
}, function (props) {
  return props.videoPresent ? 'none' : props.backgroundImage;
});
exports.Background = Background;
var Wrapper = (0, _styledComponents["default"])(_gridContainer.GridContainer).withConfig({
  displayName: "text-and-imagestyles__Wrapper",
  componentId: "sc-89ga8u-1"
})(["width:100%;grid-gap:0;user-select:none;"]);
exports.Wrapper = Wrapper;
var TextContainer = (0, _styledComponents["default"])(_gridContainer.GridContainer).withConfig({
  displayName: "text-and-imagestyles__TextContainer",
  componentId: "sc-89ga8u-2"
})(["color:", ";position:relative;grid-column:var(--grid-column);--grid-column:col-start 1 / col-end 4;padding:0 1rem;min-height:", ";display:grid;align-items:center;", " @media ", "{grid-row:1;width:100%;margin-top:50px;min-height:", ";;padding:0;", "};"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.minHeightMobile;
}, function (props) {
  return (0, _css["default"])({
    backgroundColor: props.backgroundColor
  });
}, function (props) {
  return props.theme.queries.desktopAndUp;
}, function (props) {
  return props.minHeightDesktop;
}, (0, _variant["default"])({
  prop: 'side',
  // don't collide with GridContainer's variant.
  variants: {
    'right-image': {
      '--grid-column': 'col-start 1 / col-end 7'
    },
    'left-image': {
      '--grid-column': 'col-start 6 / col-end 12'
    }
  }
}));
exports.TextContainer = TextContainer;
var FloatQuote = (0, _styledComponents["default"])(_typography.Title).withConfig({
  displayName: "text-and-imagestyles__FloatQuote",
  componentId: "sc-89ga8u-3"
})(["position:absolute;font-size:9rem;line-height:0;top:25px;z-index:1;", " @media ", "{font-size:11rem;grid-column:col-start 2 / col-end 2;left:-16px;}"], function (props) {
  return (0, _css["default"])({
    color: props.color
  });
}, function (props) {
  return props.theme.queries.desktopAndUp;
});
/**
 * Wrapper for text content of text container.
 */

exports.FloatQuote = FloatQuote;
var TextContentWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "text-and-imagestyles__TextContentWrapper",
  componentId: "sc-89ga8u-4"
})(["grid-column:var(--grid-column);--grid-column:col-start 1 / col-end 4;grid-row:1;z-index:1;display:flex;flex-direction:column;padding:42px 0;& ", ",", "{align-self:stretch;}@media ", "{& ", ",", "{align-self:flex-start;}", "}"], _linkBase["default"], _buttonBase["default"], function (props) {
  return props.theme.queries.desktopAndUp;
}, _linkBase["default"], _buttonBase["default"], (0, _variant["default"])({
  variants: {
    'right-image': {
      '--grid-column': 'col-start 2 / col-end 9'
    },
    'left-image': {
      '--grid-column': 'col-start 3 / col-end 10'
    }
  }
}));
exports.TextContentWrapper = TextContentWrapper;
var BodyContentMarkdown = (0, _styledComponents["default"])(_markdown["default"]).withConfig({
  displayName: "text-and-imagestyles__BodyContentMarkdown",
  componentId: "sc-89ga8u-5"
})(["padding:16px 0;"]);
exports.BodyContentMarkdown = BodyContentMarkdown;
var ImageContainer = (0, _styledComponents["default"])('div').withConfig({
  displayName: "text-and-imagestyles__ImageContainer",
  componentId: "sc-89ga8u-6"
})(["background-color:", ";max-height:300px;grid-column:var(--grid-column);--grid-column:col-start 1 / col-end 4;@media ", "{grid-row:1;width:100%;height:400px;max-height:400px;z-index:1;", "};img{display:block;object-fit:cover;height:100%;width:100%;}"], function (props) {
  return props.theme.colors.slate.base;
}, function (props) {
  return props.theme.queries.desktopAndUp;
}, (0, _variant["default"])({
  variants: {
    'right-image': {
      '--grid-column': 'col-start 7 / col-end 12'
    },
    'left-image': {
      '--grid-column': 'col-start 1 / col-end 6'
    }
  }
}));
exports.ImageContainer = ImageContainer;